import React from 'react';
import classNames from 'classnames';
import { SelectCard } from '../SelectCard';
import { FieldRenderProps } from 'react-final-form';
import { BUYER_OUTREACH } from 'models/Listing';
import { BUYER_OUTREACH_DATA } from '../../data';
import { useTranslation } from 'react-i18next';

import './FieldBuyerOutreach.styles.scss';
import './FieldBuyerOutreach.styles.responsive.scss';

type FieldBuyerOutreachProps = {
  className?: string;
  isRequired?: boolean;
  customOnChange?: (value: string) => void;
} & FieldRenderProps<string, HTMLElement>;

const options = Object.values(BUYER_OUTREACH);

const FieldBuyerOutreach: React.FC<FieldBuyerOutreachProps> = (props) => {
  const {
    className,
    isRequired,
    input: { value, onChange },
    customOnChange,
  } = props;

  const classes = classNames('field-buyer-outreach', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div className="left">
        <h1>{t('selectBuyerOutreach')}</h1>
      </div>

      <div className="right">
        {options.map((option) => (
          <SelectCard
            key={option}
            isSelected={value === option}
            onClick={() => {
              const newValue = value === option && !isRequired ? '' : option;
              onChange(newValue);
              customOnChange?.(newValue);
            }}
            {...BUYER_OUTREACH_DATA[option]}
          />
        ))}
      </div>
    </div>
  );
};

export default FieldBuyerOutreach;
